import angular from 'angular';

import {} from './task-table.style.scss';

import MonitoringTaskTableController from './task-table.controller';

export default angular.module('autoboard.monitoringTaskTable', [])
  .controller('MonitoringTaskTableController', MonitoringTaskTableController)
  .name;
